import { Hue } from 'annotation-tools/utils';
import { ListWithPromiseState } from '../global-state/database/common/list-with-status';
import { mapListLatest } from '../global-state/database/common/map-latest';
import { ILabelFromApi, ILabelFromApiType } from '../types/record/label';

function* idMaker(): Generator<number, number, number> {
  let i = -1;
  while (true) {
    yield i;
    i -= 1;
  }
}

const idGen = idMaker();
const getId = (): number => idGen.next().value ?? -1;

export const labelListReducer = (
  state: ListWithPromiseState<ILabelFromApiType>,
  newValue:
    | {
        type: 'init';
        listWithPromiseStatus: ListWithPromiseState<ILabelFromApiType>;
      }
    | { type: 'change'; value: [number, string] }
    | { type: 'color'; value: [number, Hue] }
    | { type: 'add' }
    | { type: 'delete'; id: number }
): ListWithPromiseState<ILabelFromApiType> => {
  switch (newValue.type) {
    case 'init':
      return newValue.listWithPromiseStatus;

    case 'change': {
      return mapListLatest(state, list => {
        const [id, name] = newValue.value;
        const targetIdx = list.findIndex(e => e.id === id);
        return list.update(targetIdx, lbl => lbl.set('name', name));
      });
    }

    case 'color': {
      return mapListLatest(state, list => {
        const [id, hue] = newValue.value;
        const targetIdx = list.findIndex(e => e.id === id);
        return list.update(targetIdx, lbl => lbl.set('hue', hue));
      });
    }

    case 'delete': {
      return mapListLatest(state, list => {
        const deleted = list.filter(e => e.id !== newValue.id);
        console.log('deleted:', deleted);
        return deleted;
      });
    }

    case 'add': {
      return mapListLatest(state, list => {
        const added = list.push(ILabelFromApi({ id: getId() }));
        return added;
      });
    }
  }
};
